import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=39e5c9bc&scoped=true&"
import script from "./CampaignList.vue?vue&type=script&lang=js&"
export * from "./CampaignList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignList.vue?vue&type=style&index=0&id=39e5c9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5c9bc",
  null
  
)

export default component.exports